var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateHistoric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 228,
    viewBox: "0 0 424 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3892_79157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7948 225.465C31.4201 225.561 24.0387 224.953 15.6521 219.267C13.9316 218.103 12.1429 216.476 12.2052 214.394C12.2517 212.826 13.4113 211.455 14.8105 210.747C15.3334 210.488 15.8847 210.292 16.4531 210.163C16.4559 210.163 16.4591 210.163 16.4591 210.159C17.3367 209.971 18.2296 209.864 19.1267 209.839L19.3825 209.829C23.6527 209.673 27.9227 210.148 32.0543 211.241C32.4284 211.338 32.8245 211.306 33.1782 211.15C33.5318 210.993 33.8221 210.721 34.0017 210.378C34.1813 210.035 34.2397 209.641 34.1674 209.261C34.0951 208.88 33.8962 208.536 33.6033 208.283C33.0698 207.826 32.4912 207.424 31.8765 207.084C30.9748 206.597 30.0295 206.195 29.0531 205.885C27.7506 205.457 26.404 205.137 25.0766 204.789C20.1428 203.507 15.3195 201.832 10.653 199.779C7.32165 198.311 3.96615 196.572 1.68694 193.728C0.640169 192.419 -0.173631 190.783 0.0319532 189.119C0.37483 186.384 3.30742 184.698 6.04048 184.354C10.8308 183.755 15.5055 185.897 19.7698 188.16C23.3074 190.043 27.259 192.116 31.1203 191.049C31.7889 190.899 32.3989 190.556 32.8749 190.062C33.7477 189.05 33.5325 187.433 32.7536 186.346C31.9746 185.259 30.765 184.582 29.5994 183.933C22.8272 180.164 16.0647 176.152 10.6604 170.594C5.2562 165.035 1.2804 157.692 1.27542 149.93C1.27542 147.66 1.62754 145.337 2.70277 143.337C3.77799 141.338 5.66026 139.693 7.8918 139.284C10.9304 138.722 13.9224 140.474 16.2222 142.538C24.1226 149.62 27.2736 160.418 31.9401 169.954C33.2462 172.623 34.7575 175.305 37.1669 177.07C37.3921 177.241 37.6514 177.363 37.9273 177.426C39.5539 177.775 40.2645 175.774 40.3392 174.247C40.6291 168.208 39.1455 161.892 41.3397 156.259C42.1781 154.114 43.6833 152.059 45.8743 151.363C48.5515 150.514 51.562 152.007 53.1701 154.314C54.7781 156.621 55.2113 159.552 55.1974 162.367C55.1726 167.585 53.764 172.721 51.6947 177.508C50.6038 180.034 49.2949 182.654 49.6065 185.386C49.7299 186.309 50.0868 187.185 50.6431 187.931C51.1994 188.677 51.9368 189.268 52.7852 189.648C53.1787 189.816 53.6018 189.903 54.0295 189.904C54.4572 189.905 54.8807 189.82 55.275 189.654C56.1258 189.289 56.7742 188.585 57.3977 187.899C57.6591 187.612 57.9209 187.322 58.1859 187.035C59.2268 185.892 60.2678 184.748 61.3088 183.603C63.9547 180.693 67.2615 177.524 71.1611 178.023C73.153 178.279 74.8012 179.52 75.9294 181.189C76.9459 182.708 77.5191 184.48 77.5844 186.307C77.7028 190.113 74.4868 201.856 72.676 205.204C70.5622 209.111 64.0272 225.135 38.7948 225.465Z",
    fill: "#5B78FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.207 225.465C391.581 225.561 398.963 224.954 407.349 219.268C409.07 218.103 410.858 216.476 410.796 214.394C410.75 212.826 409.59 211.456 408.191 210.747C407.668 210.489 407.117 210.293 406.548 210.163C406.545 210.163 406.542 210.163 406.542 210.16C405.665 209.971 404.772 209.864 403.875 209.839L403.619 209.83C399.349 209.673 395.079 210.148 390.947 211.241C390.573 211.338 390.177 211.306 389.823 211.15C389.47 210.993 389.18 210.721 389 210.378C388.82 210.035 388.762 209.641 388.834 209.261C388.907 208.881 389.106 208.536 389.398 208.283C389.932 207.826 390.51 207.424 391.125 207.084C392.027 206.597 392.972 206.196 393.948 205.885C395.251 205.457 396.597 205.137 397.925 204.789C402.859 203.508 407.682 201.833 412.348 199.781C415.68 198.313 419.035 196.574 421.315 193.73C422.362 192.421 423.175 190.785 422.969 189.121C422.627 186.386 419.694 184.7 416.961 184.356C412.171 183.757 407.496 185.899 403.232 188.162C399.694 190.045 395.742 192.118 391.881 191.05C391.212 190.901 390.602 190.557 390.126 190.064C389.254 189.052 389.469 187.435 390.248 186.348C391.027 185.261 392.236 184.584 393.402 183.934C400.174 180.166 406.937 176.154 412.341 170.595C417.745 165.037 421.718 157.694 421.725 149.932C421.725 147.662 421.373 145.339 420.298 143.339C419.222 141.34 417.34 139.695 415.108 139.286C412.07 138.724 409.078 140.476 406.778 142.54C398.878 149.621 395.727 160.419 391.062 169.954C389.755 172.624 388.244 175.306 385.835 177.07C385.61 177.242 385.35 177.364 385.074 177.427C383.448 177.776 382.737 175.775 382.662 174.248C382.373 168.209 383.856 161.893 381.662 156.26C380.824 154.115 379.318 152.06 377.127 151.364C374.45 150.515 371.44 152.007 369.832 154.315C368.224 156.622 367.79 159.553 367.804 162.368C367.829 167.586 369.238 172.722 371.307 177.509C372.398 180.035 373.707 182.655 373.395 185.387C373.272 186.31 372.915 187.186 372.359 187.932C371.802 188.678 371.065 189.269 370.216 189.649C369.823 189.817 369.4 189.904 368.972 189.905C368.544 189.906 368.121 189.821 367.727 189.655C366.876 189.29 366.227 188.586 365.604 187.9C365.343 187.613 365.081 187.323 364.816 187.035C363.775 185.893 362.734 184.749 361.693 183.604C359.047 180.694 355.741 177.525 351.84 178.024C349.849 178.28 348.2 179.521 347.072 181.19C346.056 182.708 345.483 184.481 345.417 186.308C345.299 190.114 348.515 201.857 350.326 205.204C352.437 209.111 358.972 225.135 384.207 225.465Z",
    fill: "#5B78FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.402 212.941H45.5976C41.4469 212.941 38.082 216.312 38.082 220.47V220.471C38.082 224.629 41.4469 228 45.5976 228H377.402C381.553 228 384.918 224.629 384.918 220.471V220.47C384.918 216.312 381.553 212.941 377.402 212.941Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.533 0.000244141H71.3527C65.2392 0.000244141 60.2832 4.96559 60.2832 11.0906V204.297C60.2832 210.422 65.2392 215.388 71.3527 215.388H350.533C356.647 215.388 361.603 210.422 361.603 204.297V11.0906C361.603 4.96559 356.647 0.000244141 350.533 0.000244141Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.846 7.56372H72.0407C69.3377 7.56372 67.1465 9.75905 67.1465 12.4671V202.681C67.1465 205.389 69.3377 207.584 72.0407 207.584H349.846C352.549 207.584 354.74 205.389 354.74 202.681V12.4671C354.74 9.75905 352.549 7.56372 349.846 7.56372Z",
    fill: "#E9EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.792 18.176H76.0771V198.268H344.792V18.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.792 18.176H76.0771V33.011H344.792V18.176Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.479 29.3155C338.531 29.3155 340.194 27.6491 340.194 25.5934C340.194 23.5378 338.531 21.8713 336.479 21.8713C334.427 21.8713 332.764 23.5378 332.764 25.5934C332.764 27.6491 334.427 29.3155 336.479 29.3155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.639 46.1467H93.8818V49.8799H150.639V46.1467Z",
    fill: "#E9EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.766 54.9709H93.8818V58.7041H208.766V54.9709Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.539 54.9709H220.325V58.7041H285.539V54.9709Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.143 72.6184H93.8818V76.3515H185.143V72.6184Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.539 72.6184H196.702V76.3515H285.539V72.6184Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.045 63.7942H93.8818V67.5273H235.045V63.7942Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.603 63.7942H246.604V67.5273H314.603V63.7942Z",
    fill: "#E9EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.765 81.4417H93.8818V85.1748H259.765V81.4417Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.118 81.4417H271.324V85.1748H326.118V81.4417Z",
    fill: "#E9EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.639 148.798H93.8818V152.531H150.639V148.798Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.766 157.621H93.8818V161.354H208.766V157.621Z",
    fill: "#E9EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.539 157.621H220.325V161.354H285.539V157.621Z",
    fill: "#E9EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.143 175.269H93.8818V179.002H185.143V175.269Z",
    fill: "#E9EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.539 175.269H196.702V179.002H285.539V175.269Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.045 166.445H93.8818V170.178H235.045V166.445Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.603 166.445H246.604V170.178H314.603V166.445Z",
    fill: "#E9EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.765 184.093H93.8818V187.826H259.765V184.093Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.118 184.093H271.324V187.826H326.118V184.093Z",
    fill: "#E9EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.684 102.483H93.8818V106.216H158.684V102.483Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.539 102.483H170.243V106.216H285.539V102.483Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.143 120.13H93.8818V123.863H185.143V120.13Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.83 120.13H196.702V123.863H237.83V120.13Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.765 111.307H93.8818V115.04H259.765V111.307Z",
    fill: "#E9EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.602 111.307H271.324V115.04H314.602V111.307Z",
    fill: "#E9EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.944 128.954H93.8818V132.687H207.944V128.954Z",
    fill: "#E9EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.297 128.954H219.503V132.687H274.297V128.954Z",
    fill: "#E9EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.684 137.83H93.8818V141.563H158.684V137.83Z",
    fill: "#C2CFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.539 137.83H170.243V141.563H285.539V137.83Z",
    fill: "#E9EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.639 91.9622H93.8818V95.6953H150.639V91.9622Z",
    fill: "#E9EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.265 133.521H147.6V146.151H149.265V133.521Z",
    fill: "#3758CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.273 134.355V132.687H145.591V134.355H151.273Z",
    fill: "#3758CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.273 146.668V145H145.591V146.668H151.273Z",
    fill: "#3758CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.637 105.15H294.972V117.78H296.637V105.15Z",
    fill: "#5B78FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.646 105.984V104.316H292.963V105.984H298.646Z",
    fill: "#5B78FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.646 118.297V116.629H292.963V118.297H298.646Z",
    fill: "#5B78FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3892_79157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 423,
    height: 228,
    fill: "white",
    transform: "translate(0.5 0.00012207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateHistoric);
export default __webpack_public_path__ + "static/media/EmptyStateHistoric.f4a3fd2b.svg";
export { ForwardRef as ReactComponent };